import { get, set } from './storage'
import { Notice } from './notifications'

export type WBMode = 'CSV' | 'API'
export type WeighbridgeSettings = {
  mode: WBMode
  csv?: { sample?: string } // we simulate with pasted CSV text
  api?: { url: string; token?: string }
  intervalSec: number
  overThreshold: number
  underThreshold: number
}

export type IngestTicket = {
  id: string
  scaleNumber?: string
  securityTag?: string
  grossWeight?: number
  netTons?: number
  deliveredAt?: string
}

const KEY_CFG = 'wb:settings'
const KEY_INBOX = 'wb:inbox'

export const defaultWB: WeighbridgeSettings = {
  mode:'CSV',
  intervalSec: 10,
  overThreshold: 80000,
  underThreshold: 65000,
  csv:{ sample: 'id,securityTag,scaleNumber,grossWeight,netTons,deliveredAt\n1,ST-2000,2000,81000,27.480,2025-09-18' }
}

export function loadWB(): WeighbridgeSettings { return get(KEY_CFG, defaultWB) }
export function saveWB(cfg: WeighbridgeSettings){ set(KEY_CFG, cfg) }

export function getInbox(): IngestTicket[] { return get(KEY_INBOX, []) }
export function pushInbox(list: IngestTicket[]){ set(KEY_INBOX, list) }

export function parseCSV(text: string): IngestTicket[] {
  const [header, ...lines] = text.split(/\r?\n/).filter(Boolean)
  const cols = header.split(',').map(s=>s.trim())
  return lines.map(l=>{
    const parts = l.split(',')
    const row:any = {}; cols.forEach((c,i)=> row[c] = parts[i])
    return {
      id: row.id ?? crypto.randomUUID(),
      securityTag: row.securityTag,
      scaleNumber: row.scaleNumber,
      grossWeight: row.grossWeight ? Number(row.grossWeight) : undefined,
      netTons: row.netTons ? Number(row.netTons) : undefined,
      deliveredAt: row.deliveredAt
    }
  })
}

export function applyThresholdAlerts(t: IngestTicket, cfg: WeighbridgeSettings): Notice | null {
  if (t.grossWeight && t.grossWeight > cfg.overThreshold)
    return { id:crypto.randomUUID(), ts:Date.now(), title:'WB Overweight', body:`Sec ${t.securityTag||t.scaleNumber} gross ${t.grossWeight}`, level:'warning' }
  if (t.grossWeight && t.grossWeight < cfg.underThreshold)
    return { id:crypto.randomUUID(), ts:Date.now(), title:'WB Underweight', body:`Sec ${t.securityTag||t.scaleNumber} gross ${t.grossWeight}` }
  return null
}
